import { Box } from '@mui/material';
import React from 'react';
import SettingsSideNav from './Settings/SettingsSideNav';
import SettingsHeader from './Settings/SettingsHeader';
import { useResize } from 'hooks/common';
import { useStatusBarStore } from 'stores';
import { SparkScrollableGridContainer } from 'sharedComponents/UI';

type DefaultSettingLayoutProps = { children: React.ReactNode };

function SettingLayout({ children }: DefaultSettingLayoutProps) {
  const headerRef = React.useRef<HTMLElement | null>(null);
  const statusBarHeight = useStatusBarStore((state) => state.statusBarHeight);
  const [height, setHeight] = React.useState<number>(0);

  React.useEffect(() => {
    if (!headerRef.current) return;
    const headerClientHeight = headerRef.current.clientHeight;
    const height = headerClientHeight + statusBarHeight;
    setHeight(height);
  }, [statusBarHeight]);

  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen((prev) => !prev);
  };
  const { isMobile } = useResize();

  return (
    <SparkScrollableGridContainer
      header={<SettingsHeader toggleDrawer={toggleDrawer} ref={headerRef} />}
      headerStyle={{ bgcolor: 'white', padding: 0 }}
      height={`calc(100vh - ${statusBarHeight}px)`}
      scrollableContainerStyle={{
        position: 'relative',
        padding: 0,
      }}
    >
      <Box
        display={isMobile ? '' : 'flex'}
        sx={{
          backgroundColor: (theme) => theme.palette.bgGray.light,
          width: '100%',
        }}
      >
        <SettingsSideNav
          open={open}
          toggleDrawer={toggleDrawer}
          headerHeight={height}
        />

        {children}
      </Box>
    </SparkScrollableGridContainer>
  );
}

export default SettingLayout;
